import React, { useEffect, useMemo, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import Header from "./components/header/header";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./detailPage.css";
import Tabpanels from "./components/tabpanels/tabpanles";
import { baseUrl } from "../../../../../../network/constants/constants";
import { getConfig } from "../../../../../../network/auth";
import axios from "../../../../../../network/api";

const FranchDetailPage = ({ franchise, onGoBack }) => {
  const [franchiseDetailsData, setFranchiseDetailsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);

  const franchiseId = franchise.id;

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchFranchiseDetails = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/business-by-id/${franchiseId}/`, config)
      .then((response) => {
        setFranchiseDetailsData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Franchise Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchFranchiseDetails();
  }, []);

 

  if (!franchise) {
    return <div>Select a business to see the details.</div>;
  }

  return (
    <>
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <Container fluid className="deatail-page-container mb-3">
            <button className="go-back mb-3" onClick={onGoBack}>
              <ArrowBackIcon />
              Go Back
            </button>
            <Header
              franchise={franchise}
              franchiseDetailsData={franchiseDetailsData}
              setLoading={setLoading}
              franchiseId={franchiseId}
              fetchFranchiseDetails={fetchFranchiseDetails}
              editing={editing}
            />
          </Container>

          <Container fluid className="deatail-page-container">
            <Tabpanels franchiseId={franchiseId} setEditing={setEditing} />
          </Container>
        </>
      )}
    </>
  );
};

export default FranchDetailPage;
